export enum ArticleType {
  GUIDE = 'guide',
  NEWS = 'news',
  EDUCATION = 'education',
}
